import React from 'react'
import {FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaGithub} from 'react-icons/fa'
import "./team.css";


import hardik from "../../assets/POR/hardik.png";
import harit from "../../assets/POR/Harit- Director Design.jpg";
import lovkesh from "../../assets/POR/lovkesh1.jpg";
import oishik from "../../assets/POR/Oishik.jpg";
import yash from "../../assets/POR/Yash.jpg";
import shubham from "../../assets/POR/Shubham_.jpg";
import siddhant from "../../assets/POR/Samosa - Director operations.jpg";
import pranjal from "../../assets/POR/Pranjal sharma- VP.jpg";
import shaurya from "../../assets/POR/Shwarma - Gensec.jpg";
import narayan from "../../assets/POR/Narayan tripathi- VP.jpg";

const Team = () => {
  return (
    <>
    {/* // <!-- Start Team --> */}
   <div className=".html">
    <div className="team" id="team">
      <h2 className="main-title">Team Members</h2>
      <div className="container">
        <div className="box">
          <div className="data">
            <img style={{width:'300px', height:'400px',objectFit:'cover'}} src={oishik} alt="" />
            <div className="social">
              {/* <a href="/" target="_blank">
                <FaFacebookF className="i" />
              </a> */}
              <a href="https://www.instagram.com/oishikbasu" target="_blank">
                <FaInstagram className="i" />
              </a>
              <a href="https://www.linkedin.com/in/oishikbasu" target="_blank">
                <FaLinkedinIn className="i" />
              </a>
              
            </div>
          </div>
          <div className="info">
            <h3>Oishik Basu</h3>
            <p>President</p>
          </div>
        </div>
        <div className="box">
          <div className="data">
            <img style={{width:'400px', height:'400px',objectFit:'cover'}} src={yash} alt="" />
            <div className="social">
              <a href="https://www.facebook.com/profile.php?id=100056892963088" target="_blank">
                <FaFacebookF className="i" />
              </a>
              <a href="https://www.instagram.com/yash_050902" target="_blank">
                <FaInstagram className="i" />
              </a>
              <a href="https://www.linkedin.com/in/yashaggarwal0509/" target="_blank">
                <FaLinkedinIn className="i" />
              </a>
              
            </div>
          </div>
          <div className="info">
            <h3>Yash Aggarwal</h3>
            <p>President</p>
          </div>
        </div>
        <div className="box">
          <div className="data">
            <img style={{width:'400px', height:'400px',objectFit:'cover'}} src={pranjal} alt="" />
            <div className="social">
              <a href="https://www.facebook.com/profile.php?id=100054895545342" target="_blank">
                <FaFacebookF className="i" />
              </a>
              <a href="https://www.instagram.com/pransharma15" target="_blank">
                <FaInstagram className="i" />
              </a>
              <a href="https://www.linkedin.com/in/pranjal-sharma-249637215" target="_blank">
                <FaLinkedinIn className="i" />
              </a>
              
            </div>
          </div>
          <div className="info">
            <h3>Pranjal Sharma</h3>
            <p>Vice President</p>
          </div>
        </div>
        <div className="box">
          <div className="data">
            <img style={{width:'400px', height:'400px',objectFit:'cover'}} src={narayan} alt="" />
            <div className="social">
              <a href="https://www.facebook.com/narayan.tripathi.142" target="_blank">
                <FaFacebookF className="i" />
              </a>
              <a href="https://www.instagram.com/narayan06112002" target="_blank">
                <FaInstagram className="i" />
              </a>
              <a href="https://www.linkedin.com/in/narayan-tripathi-78a9a523b" target="_blank">
                <FaLinkedinIn className="i" />
              </a>
             
            </div>
          </div>
          <div className="info">
            <h3>Narayan Tripathi</h3>
            <p>Vice President</p>
          </div>
        </div>
        <div className="box">
          <div className="data">
            <img style={{width:'400px', height:'400px',objectFit:'cover'}} src={shaurya} alt="" />
            <div className="social">
              <a href="https://www.facebook.com/taksh.aryan" target="_blank">
                <FaFacebookF className="i" />
              </a>
              <a href="https://instagram.com/thegeekyfreak" target="_blank">
                <FaInstagram className="i" />
              </a>
              <a href="https://www.linkedin.com/in/shaurya-aryan" target="_blank">
                <FaLinkedinIn className="i" />
              </a>
              
            </div>
          </div>
          <div className="info">
            <h3>Shaurya Aryan</h3>
            <p>General Secretary</p>
          </div>
        </div>
        <div className="box">
          <div className="data">
            <img style={{width:'300px', height:'400px',objectFit:'cover'}} src={hardik} alt="" />
            <div className="social">
              <a href="https://www.facebook.com/profile.php?id=100007845796982" target="_blank">
                <FaFacebookF className="i" />
              </a>
              <a href="https://www.instagram.com/chhabra_hardik01/" target="_blank">
                <FaInstagram className="i" />
              </a>
              <a href="https://www.linkedin.com/in/hardik-chhabra/" target="_blank">
                <FaLinkedinIn className="i" />
              </a>
             
            </div>
          </div>
          <div className="info">
            <h3>Hardik Chhabra</h3>
            <p>Director of Mathematics and Astronomy</p>
          </div>
        </div>
        <div className="box">
          <div className="data">
            <img style={{width:'400px', height:'400px',objectFit:'cover'}} src={siddhant} alt="" />
            <div className="social">
              {/* <a href="" target="_blank">
                <FaFacebookF className="i" />
              </a> */}
              <a href="https://www.instagram.com/siddhant.shrivastava100" target="_blank">
                <FaInstagram className="i" />
              </a>
              <a href="https://www.linkedin.com/in/siddhant-shrivastava-2b7b99203" target="_blank">
                <FaLinkedinIn className="i" />
              </a>
             
            </div>
          </div>
          <div className="info">
            <h3>Siddhant Shrivastava</h3>
            <p>Director of Operations</p>
          </div>
        </div>
        <div className="box">
          <div className="data">
            <img style={{width:'400px', height:'400px',objectFit:'cover'}} src={harit} alt="" />
            <div className="social">
              <a href="https://www.facebook.com/harit.kathuria/" target="_blank">
                <FaFacebookF className="i" />
              </a>
              <a href="https://github.com/Harit-Kathuria" target="_blank">
                <FaGithub className="i" />
              </a>
              <a href="https://www.linkedin.com/in/harit-kathuria/" target="_blank">
                <FaLinkedinIn className="i" />
              </a>
             
            </div>
          </div>
          <div className="info">
            <h3>Harit Kathuria</h3>
            <p>Director of Content</p>
          </div>
        </div>
        <div className="box">
          <div className="data">
            <img style={{width:'300px', height:'400px',objectFit:'cover'}} src={shubham} alt="" />
            <div className="social">
              {/* <a href="/" target="_blank">
                <FaFacebookF className="i" />
              </a>
              <a href="/" target="_blank">
                <FaTwitter className="i" />
              </a> */}
              <a href="https://www.linkedin.com/in/shubham-b-697639215" target="_blank">
                <FaLinkedinIn className="i" />
              </a>
             
            </div>
          </div>
          <div className="info">
            <h3>Shubham Bamnawat</h3>
            <p>Director of Graphics Design</p>
          </div>
        </div>
        
        
        <div className="box">
          <div className="data">
            <img style={{width:'400px', height:'400px',objectFit:'cover'}} src={lovkesh} alt="" />
            <div className="social">
              <a href="https://www.instagram.com/lov_kesh_11/" target="_blank">
                <FaInstagram className="i" />
              </a>
              <a href="https://github.com/lovkesh07" target="_blank">
                <FaGithub className="i" />
              </a>
              <a href="https://www.linkedin.com/in/lovkesh-patel-b4642b122/" target="_blank">
                <FaLinkedinIn className="i" />
              </a>
             
            </div>
          </div>
          <div className="info">
            <h3>Lovkesh Patel</h3>
            <p>Web Tech Lead</p>
          </div>
        </div>
      </div>
    </div>
    {/* <div className="spikes"></div> */}
   </div>
    {/* // <!-- End Team --> */}









    </>
  )
}

export default Team